import type {MessageAttachment} from '@microsoft/agent-host-protocol'
import {createContext} from 'react'
import type {MouseEvent} from 'react'

export type MessageAttachmentClickHandler = (attachment: MessageAttachment, event: MouseEvent) => void

/**
 * When provided, user-message attachment chips (e.g. repository pills) become
 * clickable. The handler receives the raw `MessageAttachment` so consumers can
 * inspect `_meta` for structured data like repo IDs.
 */
export const MessageAttachmentClickContext = createContext<MessageAttachmentClickHandler | null>(null)
